export const IsUrlFMModule = (window.location.origin === "https://web-tst.fmmodule.nl" || window.location.origin === "https://web.fmmodule.nl");

export const productInfo = {
    methods: {     
      productShortName: function() {
        return "FM"
      },
      productLongName: function() {
        return "Beheer"
      }
    }
  }